import React from 'react';

export default class AvatarType6 extends React.Component {
    render() {
        return <svg width="147px" height="147px" viewBox="0 0 147 147" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
            <defs>
                <circle id="path-1" cx="73.5" cy="73.5" r="73.5"/>
            </defs>
            <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="п">
                    <g id="Group-20">
                        {/*<mask id="mask-2" fill="white">*/}
                            {/*<use xlinkHref="#path-1"/>*/}
                        {/*</mask>*/}
                        <use id="Mask" fill="#2CA142" xlinkHref="#path-1"/>
                        <text id="П" mask="url(#mask-2)" fontFamily="Rubik-Bold, Rubik" fontSize="92" fontWeight="bold"
                              letterSpacing="-0.1571431" fill="#FFFFFF" textAnchor="middle">
                            <tspan x="73.5" y="105">{this.props.text}</tspan>
                        </text>
                    </g>
                </g>
            </g>
        </svg>
    }
}


// WEBPACK FOOTER //
// ./src/components/Presentation/Avatar/type6.js